import * as Enums from '../models/enum';
import { TimeInterval } from './timeInterval';

export class AggregationConfiguration {
    mode: Enums.AggregationMode;
    period: TimeInterval;

   constructor() {
        this.mode = Enums.AggregationMode.None;
        this.period = new TimeInterval();
    }
}